import * as React from 'react';
import { Props } from 'react';
import { setTimeout, clearTimeout } from 'timers';

import '../RegistrationAuthorization/RegistrationAuthorization.scss';
import i18next from 'i18next';
import PhoneInput from 'react-phone-input-2';

interface RegistrationViewProps extends Props<RegistrationView> {
    bin: string;
    name: string;
    surname: string;
    phone: string;
    error: string;
    checkBin: boolean;
    channelId: string;
    setBin: (bin: string) => any;
    setName: (name: string) => any;
    setSurname: (surname: string) => any;
    setPhone: (phone: string) => any;
    onRegistration: () => any;
}

interface RegistrationViewState {
    isShowError: boolean;
}

export class RegistrationView extends React.Component<RegistrationViewProps, RegistrationViewState> {
    timer: NodeJS.Timer;

    state = {
        isShowError: false
    };

    showError = () => {
        this.setState({
            isShowError: true,
        }, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            setTimeout(() => this.setState({
                isShowError: false
            }), 50000);
        });
    }

    onValueChange = (e: any) => {
        const { setPhone } = this.props;
        setPhone(e.replace(/[^0-9]+/g, ''));
    }

    componentDidMount() {
        const {error} = this.props;
        if (error) {
            this.showError();
        }
    }

    componentWillReceiveProps(next: RegistrationViewProps) {
        if (next.error && (next.error !== this.props.error)) {
            this.showError();
        }
    }

    render() {
        const {bin, name, surname, phone, error} = this.props;
        const {setBin, setName, setSurname, onRegistration, checkBin, channelId} = this.props;
        const {isShowError} = this.state;
        const countries = ['am', 'ao', 'gr', 'ge', 'az', 'uz', 'si', 'fr', 'it', 'hu', 'cz',
            'bh', 'sg', 'mk', 'at', 'pl', 'lt', 'mt', 'be', 'ro', 'kw', 'es', 'au',
            'jo', 'tr', 'ch', 'lv', 'ae', 'de', 'us', 'gb', 'il', 'kz', 'ua', 'by', 'ru'];

        return (
            <div className={`registration-container ${channelId}`}>
                <div className={`registration ${channelId}`}>
                    <div className={`reg-tab ${channelId}`}>
                        <div className={`reg-title reg-title-${channelId}`}>
                            {i18next.t('registration')}
                        </div>
                    </div>
                    <div className={`reg-error ${isShowError ? 'show' : ''}`} dangerouslySetInnerHTML={{__html: error}} />
                    <div className='reg-body'>
                        <div className='reg-body-title'>
                            {i18next.t('we_are_not_familiar')}<br/>
                            {i18next.t('its_easy_to_fix')}
                        </div>
                        <div className='reg-body-field'>
                            <input
                                autoComplete='off'
                                className={!bin ? 'input-gray' : ''}
                                value={bin}
                                onChange={(e) => setBin(e.target.value)}
                                maxLength={6}
                                placeholder={i18next.t('iin')}
                            />
                        </div>
                        <div className='reg-body-field'>
                            <input
                                autoComplete='off'
                                className={!name ? 'input-gray' : ''}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={i18next.t('your_name')}
                            />
                        </div>
                        <div className='reg-body-field'>
                            <input
                                autoComplete='off'
                                className={!surname ? 'input-gray' : ''}
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                                placeholder={i18next.t('your_second_name')}
                            />
                        </div>
                        <div className='reg-body-phone'>
                            <PhoneInput
                                onlyCountries={countries}
                                preferredCountries={['ru', 'by', 'am', 'ge', 'az', 'ua', 'kz', 'uz']}
                                preserveOrder={['onlyCountries', 'preferredCountries']}
                                value={'+' + phone}
                                disableAreaCodes={true}
                                autoFocus={true}
                                autoFormat={false}
                                onChange={this.onValueChange}
                                placeholder={i18next.t('phone_number')}
                                enableSearchField={true}
                                dropdownClass={'phone-code-flag'}
                                buttonClass={'phone-flag-dropdown'}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='reg-button-container'>
                            <div className={`reg-button ${channelId} ${!phone || !bin || !name || !surname || !checkBin ? 'auth-gray' : ''}`} onClick={() => phone && bin && name && surname && checkBin && onRegistration()}>
                                {i18next.t('ok')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationView.tsx